<!-- !! Attention: Student account會共用呢個page，留意返啲permission !! -->
<template>
  <v-container fluid>
    <PageHeaderSlot :showBackButton="$route.name !== 'StudentUserAttendance'" />

    <!-- 套票紀錄 -->
    <v-progress-linear indeterminate color="primary darken-2" v-if="quotaLoading"></v-progress-linear>
    <v-card class="mb-6">
      <v-card-text class="px-4">
        <h6 class="text-h6 colorBlack--text mb-6">{{ $t('packageRecord') }}</h6>
        <v-row>
          <v-col cols="12" sm="4" lg="3">
            <div class="package-item">
              <span>{{ $t('canUseLessonCount') }} : </span>
              <span>{{ packageLessonCanUse }}</span>
            </div>
          </v-col>
          <v-col cols="12" sm="4" lg="3">
            <div class="package-item">
              <span>{{ $t('unassignLesson') }} : </span>
              <span class="text-right">
                {{ packageLessonAvailable }}
                <v-btn
                  v-if="packageLessonAvailable > 0 && canAssignLesson"
                  depressed
                  elevation="0"
                  plain
                  color="primary"
                  class="d-block text-decoration-underline pa-0 btn-assign"
                  small
                  @click.prevent="openAssignLesson()"
                >
                  {{ $t('assignLesson') }}
                </v-btn>
              </span>
            </div>
          </v-col>
          <v-col cols="12" sm="4" lg="3">
            <div class="package-item">
              <span>{{ $t('toBeAttended') }} : </span>
              <span>{{ packagePendingAttend }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" lg="3">
            <div class="package-item">
              <span>{{ $t('usedLessonCountAttend') }} : </span>
              <span>{{ packageLessonUsedAttend }}</span>
            </div>
          </v-col>
          <v-col cols="12" sm="4" lg="3">
            <div class="package-item">
              <span>{{ $t('usedLessonCountAbsent') }} : </span>
              <span>{{ packageLessonUsedAbsent }}</span>
            </div>
          </v-col>
          <v-col cols="12" sm="4" lg="3">
            <div class="package-item">
              <span>{{ $t('totalPackageLessonCount') }} : </span>
              <span>{{ packageTotalLesson }}</span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Summary -->
    <v-progress-linear indeterminate color="primary darken-2" v-if="summaryLoading"></v-progress-linear>
    <v-toolbar flat class="custom-table-toolbar mb-6 no-wrap attendance-toolbar" height="auto">
      <v-toolbar-items class="toolbar-left-items flex-grow-1 justify-space-between">
        <FormDatePicker
          :dateValue.sync="selectedYearMonth"
          hideDetails
          customInputClass="mr-3 mt-2 mb-3 search-input-field"
          :disabled="summaryLoading"
          @changed="getMonthAttendanceSummary()"
          isYearMonthOnly
          disableClear
        />

        <div class="attendance-toolbar__item">{{ $t('totalLessonCount') }} : {{ totalLessons }}</div>
        <div class="attendance-toolbar__item">{{ $t('attend') }} : {{ attends }}</div>
        <div class="attendance-toolbar__item">{{ $t('absent') }} : {{ absents }}</div>
        <div class="attendance-toolbar__item">{{ $t('upcoming') }} : {{ pending }}</div>
      </v-toolbar-items>
    </v-toolbar>

    <!-- 上堂紀錄 -->
    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      :itemTotal="tableItemTotal"
      enableClearAll
      @all-search-cleared="clearSearch()"
      @refresh-clicked="refreshData()"
      enableRefresh
      @options-update="getAttendanceData()"
      actionViewRouteLink="ClassDetails"
    >
      <template slot="append-toolbar-left">
        <FormSelect
          :fieldValue.sync="tableFilter.dateType"
          :options="dateTypeOptions"
          hideDetails
          @changed="dateTypeChanged()"
          class="mr-3 mt-2 mb-3 search-select-field"
          :readonly="tableLoading"
        />
        <FormDatePicker
          isDateRange
          :dateValue.sync="tableFilter.dates"
          hideDetails
          customInputClass="mr-3 mt-2 mb-3 search-input-field"
          placeholder="classDate"
          @changed="search()"
          :disabled="tableFilter.dateType !== 'custom'"
          :readonly="tableLoading"
        />
        <FormSelect
          :fieldValue.sync="tableFilter.status"
          :options="attendanceStatusOptions"
          hideDetails
          placeholder="searchAttendStatus"
          enableClear
          @changed="search()"
          class="mr-3 mt-2 mb-3 search-select-field"
          enableTooltip
          :readonly="tableLoading"
        />
      </template>
      <template v-slot:[`item.attendance`]="{ item }">
        <v-chip
          :class="{
            'chip-active': item.attendance === 'attend',
            'chip-inactive': item.attendance === 'absent',
            'chip-await': item.attendance === 'await' || item.attendance === 'sick_leave',
          }"
        >
          {{ item.attendance | formatAttendanceStatus }}
        </v-chip>
      </template>
      <template v-slot:[`item.actionProgress`]="{ item }">
        <div class="d-flex align-center justify-end">
          <FormButton text="lessonProgress" small @click="openViewProgress(item.id)" />
          <v-btn
            class="whatsapp my-0 ml-1"
            text
            small
            min-width="30px"
            max-width="30px"
            @click.prevent="handleSendProgress(item.id)"
            :loading="$store.getters.isLoading"
          >
            <v-icon size="20" color="white">{{ icon.mdiWhatsapp }}</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:[`item.viewProgress`]="{ item }">
        <div class="d-flex align-center justify-end">
          <v-btn
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0 mr-4"
            small
            @click="viewLatestProgress(item.id)"
          >
            <v-icon class="fi fi-rr-eye mr-1" size="15"></v-icon>
            {{ $t('comment') }}
          </v-btn>
        </div>
      </template>
    </Datatable>

    <!-- Modal: 課堂進度 -->
    <DialogLayout ref="lessonProgressDialog" title="lessonProgress" hideAction cardContentClass="pa-0">
      <Datatable
        :isLoading="progressTable.loading"
        :tableData="progressTable.list"
        :tableHeaders="progressTableHeaders"
        :itemTotal="progressTable.total"
        :page.sync="progressTable.page"
        :pageLimit.sync="progressTable.limit"
        @options-update="getProgressData()"
        @edit-clicked="handleAddProgress($event)"
      >
        <template slot="append-toolbar-left">
          <FormButton v-if="canEdit" isAdd text="add" class="my-2" @click="handleAddProgress()" />
        </template>
        <template v-slot:[`item.video_url`]="{ item }">
          <v-btn
            v-if="item.video_url"
            @click.prevent="previewVideo(item.video_url)"
            text
            depressed
            small
            color="primary"
          >
            {{ item.custom_video_title || item.video_title || '' }}
          </v-btn>
        </template>
      </Datatable>
    </DialogLayout>
    <!-- Modal: 新增課堂進度 -->
    <FormDialog title="lessonProgress" :maxWidth="500" ref="progressDialog" formRef="progressForm">
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="lessonProgressInput" :fieldValue.sync="progressData.progress" required />
        </v-col>
        <v-col cols="12">
          <FormInput label="commentInput" :fieldValue.sync="progressData.comment" />
        </v-col>
      </v-row>
      <v-row class="ma-0" v-if="gEnableLessonProgressVideo">
        <v-col cols="12">
          <FormUploader
            ref="uploadProgressVideoRef"
            fileInputKey="upload_progress_video"
            :files.sync="progressData.video_list"
            :acceptFormat="['vimeo']"
            single
          />
        </v-col>
        <v-col cols="12" class="d-flex">
          <FormButton text="pasteVideo" @click="pasteVideo()" />
          <FormButton
            v-if="$validate.DataValid(progressData.video_list, true) && progressData.video_list[0].video_id"
            text="copyVideo"
            @click="copyVideo()"
            class="ml-2"
          />
          <FormButton text="searchVideo" @click="openSearchVideo()" class="ml-2" />
        </v-col>
      </v-row>
    </FormDialog>
    <!-- Modal: 搜尋影片 -->
    <DialogLayout ref="searchVideoDialog" title="searchVideo" hideAction cardContentClass="pa-0">
      <Datatable
        :isLoading="videoTable.loading"
        :tableData="videoTable.list"
        :tableHeaders="videoTableHeaders"
        :itemTotal="videoTable.total"
        :page.sync="videoTable.page"
        :pageLimit.sync="videoTable.limit"
        @options-update="searchVideo()"
      >
        <template v-slot:[`item.thumbnail`]="{ item }">
          <v-img :src="item.thumbnail" contain :max-height="200" :max-width="200"></v-img>
        </template>
        <template v-slot:[`item.duration`]="{ item }">{{ gfConvertDuration(item.duration) }}</template>
        <template v-slot:[`item.video_url`]="{ item }">
          <v-btn
            v-if="item.videoInput.url"
            @click.prevent="previewVideo(item.videoInput.url)"
            text
            depressed
            small
            color="primary"
          >
            {{ item.videoInput.name }}
          </v-btn>
        </template>
        <template v-slot:[`item.actionSelect`]="{ item }">
          <v-btn
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            style="min-width: unset !important;"
            @click="handleSelectVideo(item)"
          >
            {{ $t('select') }}
          </v-btn>
        </template>
      </Datatable>
    </DialogLayout>

    <!-- Modal: WhatsApp傳送課堂進度 -->
    <FormDialog ref="selectWtsDialog" formRef="selectWtsForm" title="selectWhatsappPhone" :maxWidth="500">
      <v-row class="ma-0">
        <v-col cols="12">{{ wtsMsg }}</v-col>
        <v-col cols="12">
          <v-radio-group
            name="selectWhatsappPhone"
            v-model="wtsPhone"
            class="ma-0"
            :rules="[v => this.$validate.required(v)]"
          >
            <v-radio
              v-for="(item, index) in wstPhoneOptions"
              :label="item.text"
              :value="item.value"
              :key="index"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 指派課堂 -->
    <AssignLessonDialog
      v-if="canAssignLesson"
      ref="assignLessonDialog"
      title="assignLesson"
      :loading="assignFilter.loading"
      :courseNameOptions="courseNameOptions"
      :courseNameSearching="courseNameSearching"
      :tutorOptions="tutorOptions"
      :disableGrade="disableCourseGrade"
      filterLessonType="weekday"
      :filterCourseName.sync="assignFilter.keyword"
      :filterDates.sync="assignFilter.dateRange"
      :filterWeekdays.sync="assignFilter.weekdays"
      :filterTutor.sync="assignFilter.tutor"
      :filterGrade.sync="assignFilter.grade"
      :filterPage.sync="assignFilter.page"
      :filterLimit.sync="assignFilter.limit"
      :filterCenter="userSelectedSchool"
      :tableData="assignFilter.tableData"
      :tableHeaders="assignLessonTableHeaders"
      :tableTotal="assignFilter.total"
      :tempSelectedLesson="assignFilter.selectedLesson"
      @filter-update="onCourseFilterChange()"
      @options-update="searchCourses()"
      @close="handleAssignLessonActionClick($event)"
    >
      <template slot="extra">
        <v-row class="ma-0 px-4">
          <v-col cols="12"><v-divider></v-divider></v-col>

          <v-col cols="4">
            <label class="input-label">{{ $t('unassignLesson') }}</label>
            <div>{{ packageLessonAvailable }}</div>
          </v-col>
          <v-col cols="4">
            <label class="input-label">{{ $t('toBeAttended') }}</label>
            <div>{{ packagePendingAttend }}</div>
          </v-col>

          <v-col cols="12" v-if="!isAppMode(['T01'])">
            <label class="input-label">{{ $t('applyRuleType') }}</label>

            <v-radio-group
              name="applyRuleType"
              v-model="assignFilter.packageLessonRule"
              row
              hide-details
              class="ma-0"
              @change="onPackageRuleChanged()"
              :readonly="assignFilter.loading"
            >
              <v-radio :label="$t('autoGrabLesson')" value="auto"></v-radio>
              <v-radio :label="$t('customLesson')" value="manually"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12">
            <small class="d-block text-caption mt-2">{{ $t('packageDes') }}</small>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`actionSelectCourse`]="{ item }">
        <div class="colorGrey--text pointer-none" v-if="item.applied">{{ $t('lessonStatus.applied') }}</div>
        <v-btn
          v-else
          :loading="$store.getters.isLoading"
          depressed
          text
          :color="isItemSelected(item.id) ? 'red' : 'primary'"
          :ripple="false"
          class="pa-0"
          :class="{ 'pointer-none': $store.getters.isLoading }"
          style="min-width: unset !important;"
          @click="handlePackageLessonSelected(item.id)"
        >
          {{ $t(isItemSelected(item.id) ? 'cancel' : 'apply') }}
        </v-btn>
      </template>
    </AssignLessonDialog>
  </v-container>
</template>

<script>
import { mdiWhatsapp } from '@mdi/js'
import Datatable from '@/components/Datatable.vue'
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import FormDialog from '@/components/FormDialog.vue'
import FormInput from '@/components/formField/FormInput.vue'
import DialogLayout from '@/components/layout/DialogLayout.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import FormUploader from '@/components/formField/FormUploader.vue'
import AssignLessonDialog from '../PayTuition/components/AssignLessonDialog.vue'

export default {
  name: 'StudentAttendance',
  components: {
    Datatable,
    FormDatePicker,
    FormDialog,
    FormInput,
    DialogLayout,
    FormSelect,
    FormUploader,
    AssignLessonDialog,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [
        { value: 'date', text: vm.$t('classDate'), width: 200 },
        { value: 'timeslot', text: vm.$t('time'), width: 200 },
        ...(this.gDisableEmptyCode ? [{ value: 'course_code', text: vm.$t('courseCode') }] : []),
        { value: 'course_name', text: vm.$t('courseName') },
        ...(!this.isAppMode(['T01']) ? [{ value: 'order_code', text: vm.$t('orderCode') }] : []),
        { value: 'attendance', text: vm.$t('attendStatus'), align: 'center', width: 160 }
      ]

      if (!this.gDisableLessonProgress) {
        if (this.canEdit) {
          headers.push({ value: 'actionProgress', text: '', align: 'end' })
        } else if (!this.isAppMode(['T04']) && this.userType === 'student') {
          headers.push({ value: 'viewProgress', text: '', align: 'end' })
        }
      }

      if (this.$validate.allowAction('ClassDetails', this.userType)) {
        headers.push({ value: 'actionView', text: '', align: 'end', width: 80 })
      }

      return headers
    },
    progressTableHeaders() {
      const vm = this
      const headers = [
        { value: 'create_date', text: vm.$t('date'), width: 130 },
        { value: 'progress', text: vm.$t('lessonProgress') },
        { value: 'comment', text: vm.$t('comment') },
      ]
      if (this.gEnableLessonProgressVideo) {
        headers.push({ value: 'video_url', text: vm.$t('uploadVideo') })
      }
      if (this.canEdit) {
        headers.push({ value: 'minActionEdit', text: '', align: 'end' })
      }
      return headers
    },
    assignLessonTableHeaders() {
      const vm = this
      let headers = [
        { value: 'course_name', text: vm.$t('purchaseItem') },
        { value: 'full_date', text: vm.$t('date'), hasWeekday: true },
        { value: 'timeslot', text: vm.$t('time') },
      ]
      if (!this.disableCourseGrade) {
        headers.push({ value: 'grade', text: vm.$t('grade') })
      }
      headers = [
        ...headers,
        { value: 'tutor', text: vm.$t('tutor') },
        { value: 'current_per_max_student_num', text: vm.$t('personCount') },
        { value: 'actionSelectCourse', text: '', align: 'end' },
      ]
      return headers
    },
    // permission / setting
    canEdit() {
      return this.$validate.allowAction('editClass', this.userType)
    },
    canAssignLesson() {
      return this.$validate.allowAction('PayTuitionPayment', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    userSelectedSchool: -1,
    id: null,
    disableCourseGrade: false,

    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
      dates: [],
      status: null,
      dateType: 'pass',
    },

    selectedYearMonth: '',
    totalLessons: 0,
    attends: 0,
    absents: 0,
    pending: 0,

    quotaLoading: true,
    packageLessonCanUse: 0,
    packageLessonAvailable: 0,
    packagePendingAttend: 0,
    packageLessonUsedAttend: 0,
    packageLessonUsedAbsent: 0,
    packageTotalLesson: 0,

    summaryLoading: true,

    progressData: {
      progress: '',
      comment: '',
      video_list: [],
    },
    progressTable: {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      limit: 10,
      lesson_id: -1,
    },
    wtsPhone: null,
    wstPhoneOptions: [],
    wtsMsg: '',

    videoTable: {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      limit: 10,
    },

    assignFilter: {
      loading: false,
      tableData: [],
      selectedRow: [],
      selectedLesson: [],
      total: 0,
      // filter
      keyword: '',
      weekdays: [],
      dateRange: [],
      tutor: null,
      grade: '',
      packageLessonRule: 'auto', // 'auto' | 'manually'
      page: 1,
      limit: vm.isAppMode(['T37']) ? 20 : 5,
    },
    courseNameOptions: [],
    courseNameSearching: false,
    tutorOptions: [],

    icon: {
      mdiWhatsapp,
    },
    videoTableHeaders: [
      { value: 'thumbnail', text: vm.$t('videoCover'), width: 230 },
      { value: 'duration', text: vm.$t('videoDuration') },
      { value: 'video_url', text: vm.$t('video') },
      { value: 'actionSelect', text: '', align: 'end', width: 120 },
    ],
    attendanceStatusOptions: [
      { value: 'pending', text: vm.$t('attendanceStatus.pending') },
      { value: 'attend', text: vm.$t('attendanceStatus.attend') },
      { value: 'absent', text: vm.$t('attendanceStatus.absent') },
      { value: 'skip', text: vm.$t('attendanceStatus.skip') },
      { value: 'reschedule', text: vm.$t('rescheduleSingle') },
      { value: 'swap', text: vm.$t('attendanceStatus.swap') },
      { value: 'drop', text: vm.$t('attendanceStatus.drop') },
      { value: 'await', text: vm.$t('attendanceStatus.await') },
    ],
    dateTypeOptions: [
      { value: 'pass', text: vm.$t('dateFilterOptions.pass') },
      { value: 'future', text: vm.$t('dateFilterOptions.future') },
      { value: 'all', text: vm.$t('dateFilterOptions.all') },
      { value: 'custom', text: vm.$t('dateFilterOptions.custom') },
    ],
  }),
  methods: {
    // ===== 套票紀錄 =====
    async getStudentPackageInfo() {
      this.quotaLoading = true
      this.packageTotalLesson = 0
      this.packageLessonUsedAttend = 0
      this.packageLessonUsedAbsent = 0
      this.packagePendingAttend = 0
      this.packageLessonAvailable = 0
      this.packageLessonCanUse = 0

      let next = true
      try {
        const data = await this.$Fetcher.GetStudentPackageInfo(this.id)
        this.packageTotalLesson = data.quota_total // 已購買總堂數
        this.packageLessonUsedAttend = data.quota_used_attend // 已使用堂數 (出席)
        this.packageLessonUsedAbsent = data.quota_used_absent // 已使用堂數 (缺席)
        this.packagePendingAttend = data.quota_used_pending // 待出席
        this.packageLessonAvailable = data.quota_available // 未指派課堂
        this.packageLessonCanUse = data.quota_can_use // 可用堂數 = 未指派課堂 + 待出席
      } catch (err) {
        this.$common.error(err)
        if (err === 'abort') {
          next = false
        }
      }
      this.quotaLoading = false
      if (next) next = await this.getAttendanceData()
      if (next) this.getMonthAttendanceSummary()
    },

    // -- (指派課堂)
    async openAssignLesson() {
      this.assignFilter.loading = true
      this.assignFilter.selectedRow = []
      this.assignFilter.selectedLesson = []
      this.assignFilter.tableData = []
      this.assignFilter.total = 0
      this.assignFilter.keyword = ''
      this.assignFilter.weekdays = []
      this.assignFilter.dateRange = []
      this.assignFilter.tutor = null
      this.assignFilter.grade = ''
      this.assignFilter.packageLessonRule = 'auto'
      this.assignFilter.page = 1

      this.$refs.assignLessonDialog.show('search_lesson')

      if (this.tutorOptions.length < 1) {
        await this._getTutorOptions()
      }
      this._getCourseNameOption()
      this.searchCourses()
    },
    async _getTutorOptions() {
      try {
        let payload = {}
        if (this.userSelectedSchool > -1) payload['center'] = [this.userSelectedSchool]

        const { data } = await this.$Fetcher.GetStaffs(payload)
        this.tutorOptions = data.map(el => {
          return { value: el.id, text: el.name }
        })
      } catch {}
    },
    async _getCourseNameOption() {
      if (this.courseNameOptions.length < 1 && !this.courseNameSearching) {
        this.courseNameSearching = true
        this.courseNameOptions = await this.$Fetcher.GetAllCourseNames(this.userSelectedSchool, true)
        this.courseNameSearching = false
      }
    },
    async searchCourses() {
      this.assignFilter.loading = true
      this.assignFilter.tableData = []

      let payload = {
        controller_name: 'search_lesson',
        filter_page: this.assignFilter.page - 1,
        filter_limit: this.assignFilter.limit,
        join_tutor_data: true,
        filter_item: [{ key: 'lesson_type', value: 'regular' }],
      }
      if (this.userSelectedSchool > -1) payload['center_id'] = this.userSelectedSchool

      if (this.$validate.DataValid(this.assignFilter.keyword)) {
        payload['filter_item'].push({ key: 'course_name', value: this.assignFilter.keyword })
      }
      if (this.$validate.DataValid(this.assignFilter.tutor) && this.assignFilter.tutor > -1) {
        payload['filter_item'].push({ key: 'staff_id', value: this.assignFilter.tutor })
      }
      if (this.$validate.DataValid(this.assignFilter.grade) && this.assignFilter.grade !== 'all') {
        payload['filter_item'].push({ key: 'grade', value: this.assignFilter.grade })
      }
      if (this.$validate.DataValid(this.assignFilter.weekdays, true)) {
        const weekdays = this.assignFilter.weekdays.map(el => parseInt(el))
        payload['filter_item'].push({ key: 'weekdays', value: weekdays })
      }

      const startDate = this.$formatter.convertDate()
      if (this.isAppMode(['T11', 'T17'])) {
        // 可以揀當月過咗期嘅lesson
        startDate.setDate(1)
      } else if (this.isAppMode(['T14'])) {
        // 可以攞一個月前嘅lesson
        startDate.setDate(1)
        startDate.setMonth(startDate.getMonth() - 1)
      }
      payload['filter_item'].push({ key: 'start_date', value: this.$formatter.formatDate(startDate) })
      if (this.$validate.DataValid(this.assignFilter.dateRange, true) && this.assignFilter.dateRange[0]) {
        const foundPos = payload.filter_item.findIndex(el => el.key === 'start_date')
        if (
          this.assignFilter.dateRange.length > 1 &&
          this.assignFilter.dateRange[1] &&
          this.assignFilter.dateRange[1] !== this.assignFilter.dateRange[0]
        ) {
          payload['filter_item'][foundPos].value = this.assignFilter.dateRange[0]
          payload['filter_item'].push({ key: 'end_date', value: this.assignFilter.dateRange[1] })
        } else {
          payload['filter_item'].splice(foundPos, 1)
          payload['filter_item'].push({ key: 'date', value: this.assignFilter.dateRange[0] })
        }
      }

      try {
        const { data, total } = await this.$Fetcher.GetLessons(payload)
        this.assignFilter.total = total
        this.assignFilter.tableData = data.map(el => {
          return {
            id: el.id, // lesson id
            lesson_type: el.lesson_type,
            course_id: el.course_id,
            regular_id: el.regular_id,
            course_name: el.course_name,
            course_code: el.course_code,
            date: el.date,
            start_time: el.start_time,
            end_time: el.end_time,
            grade: el.grade,
            tutor: el.tutor_data_list.map(t => t.name).join(', '),
            current_student_num: el.current_student_num,
            max_student: el.max_student,
            unit_price: el.price,

            applied: el.student_ids.includes(this.id),
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.assignFilter.tableData = []
        if (this.assignFilter.page === 1) {
          this.assignFilter.total = 0
        }
      } finally {
        this.assignFilter.loading = false
        this.$common.logData(this.assignFilter.tableData, 'Search Lesson')
      }
    },
    onCourseFilterChange() {
      this.assignFilter.page = 1
      this.assignFilter.total = 0
      this.searchCourses()
    },
    onPackageRuleChanged() {
      this.assignFilter.selectedLesson = []
      this.assignFilter.selectedRow = []
    },

    isItemSelected(id) {
      const found = this.assignFilter.selectedRow.find(el => el.id === id)
      if (found) return true

      return false
    },
    async handlePackageLessonSelected(lesson_id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const targetLesson = this.assignFilter.tableData.find(el => el.id === lesson_id)
        const foundPos = this.assignFilter.selectedRow.findIndex(el => el.id === lesson_id)

        if (this.assignFilter.packageLessonRule === 'manually') {
          // 手動選擇報讀課堂
          const foundTemp = this.assignFilter.selectedLesson.findIndex(el => el.id === lesson_id)
          if (foundPos > -1) {
            this.assignFilter.selectedRow.splice(foundPos, 1)
            this.assignFilter.selectedLesson.splice(foundTemp, 1)
          } else {
            if (this.assignFilter.selectedLesson.length >= this.packageLessonAvailable) {
              this.$store.dispatch('setLoading', false)
              this.$store.dispatch('toggleSnack', {
                message: 'message.lessonCountNotEnough',
                type: 'error',
              })
              return
            }

            this.assignFilter.selectedRow.push(targetLesson)
            if (foundTemp < 0) {
              this.assignFilter.selectedLesson.push(targetLesson)
            }

            this.assignFilter.selectedLesson.sort((a, b) =>
              this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
            )
          }
        } else {
          // 自動報讀
          if (foundPos > -1) {
            this.assignFilter.selectedRow.splice(foundPos, 1)
          } else {
            const foundSameCourse = this.assignFilter.selectedRow.findIndex(
              el => el.course_code === targetLesson.course_code,
            )
            this.assignFilter.selectedRow.splice(foundSameCourse, 1)
            this.assignFilter.selectedRow.push(targetLesson)
          }

          this.assignFilter.selectedRow.sort((a, b) =>
            this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
          )

          // 搵related lesson
          let relatedLessons = []
          if (this.assignFilter.selectedRow.length) {
            const courseCodes = this.assignFilter.selectedRow.map(el => el.course_code)
            const minDate = this.$formatter.convertDate(this.assignFilter.selectedRow[0].date)
            minDate.setDate(minDate.getDate() - 1)

            let payload = {
              student_id: this.id,
              date: this.$formatter.formatDate(minDate),
              course_codes: courseCodes,
              selected_first_lessons: this.assignFilter.selectedRow.map(el => {
                return {
                  course_code: el.course_code,
                  date: el.date,
                  start_time: el.start_time,
                }
              }),
              max_count: this.packageLessonAvailable,
            }
            relatedLessons = await this.$Fetcher.GetPackageLessonsPreview(payload)
          }

          this.assignFilter.selectedLesson = JSON.parse(JSON.stringify(relatedLessons))
        }
        this.$common.logData(this.assignFilter.selectedRow, 'Selected Rows')
        this.$common.logData(this.assignFilter.selectedLesson, 'Selected Lessons')
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    async handleAssignLessonActionClick(action) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      if (action === true) {
        // 冇揀lesson，reject
        if (this.assignFilter.selectedLesson.length < 1) {
          this.$store.dispatch('toggleSnack', {
            message: 'message.atLeastOneLesson',
            type: 'error',
          })
          return
        }

        // 唔夠package count，reject
        if (this.assignFilter.selectedLesson.length > this.packageLessonAvailable) {
          this.$store.dispatch('toggleSnack', {
            message: 'message.lessonCountNotEnough',
            type: 'error',
          })
          return
        }

        // assign
        this.$store.dispatch('setLoading', true)
        try {
          const lessonIds = this.assignFilter.selectedLesson.map(el => el.id)
          await this.$Fetcher.AddStudentToLessonWithPackage(lessonIds, this.id)

          this.$refs.assignLessonDialog.hide()
          this.$store.dispatch('toggleSnack', {
            message: 'message.createSuccess',
            type: 'success',
          })
          this.quotaLoading = true
          this.tableLoading = true
          this.summaryLoading = true
          setTimeout(() => {
            this.getStudentPackageInfo()
          }, 500)
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.createFail',
            message: err,
            isError: true,
          })
        }

        this.$store.dispatch('setLoading', false)
      } else {
        this.$refs.assignLessonDialog.hide(true)
      }
    },

    // ===== 總紀錄 =====
    async getMonthAttendanceSummary() {
      this.summaryLoading = true
      try {
        let payload = {
          filter_item: [{ key: 'attendance_status', value: ['pending', 'attend', 'absent', 'await', 'sick_leave'] }],
        }

        if (!this.selectedYearMonth) {
          this.selectedYearMonth = today.substring(0, 7)
        }
        const year = this.selectedYearMonth.substring(0, 4)
        const month = this.selectedYearMonth.substring(5, 7)
        const startDate = this.$formatter.convertDate(`${year}-${month}-01`)
        payload['filter_item'].push({ key: 'start_date', value: this.$formatter.formatDate(startDate) })
        const lastDateOfMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0)
        payload['filter_item'].push({ key: 'end_date', value: this.$formatter.formatDate(lastDateOfMonth) })

        const { total, attend, absent, pending } = await this.$Fetcher.GetStudentAttendances(this.id, payload)
        this.totalLessons = total
        this.attends = attend
        this.absents = absent
        this.pending = pending
      } catch (err) {
        this.$common.error(err)
        this.totalLessons = 0
        this.attends = 0
        this.absents = 0
        this.pending = 0
      } finally {
        this.summaryLoading = false
      }
    },

    // ===== 上堂紀錄 =====
    async getAttendanceData() {
      this.tableLoading = true
      try {
        let payload = {
          filter_limit: this.tableFilter.limit,
          filter_page: this.tableFilter.page - 1,
          filter_item: [],
          get_order: '',
        }

        let selectYearChanged = false
        if (this.tableFilter.dateType === 'pass') {
          const date = this.$formatter.convertDate()
          date.setDate(date.getDate() - 1)
          payload['filter_item'].push({ key: 'end_date', value: this.$formatter.formatDate(date) })
        } else if (this.tableFilter.dateType === 'future') {
          this.tableFilter.dates = []
          const date = this.$formatter.convertDate()
          payload['filter_item'].push({ key: 'start_date', value: this.$formatter.formatDate(date) })
          this.tableFilter.dates.push(this.$formatter.formatDate(date))
          date.setDate(date.getDate() + 30)
          payload['filter_item'].push({ key: 'end_date', value: this.$formatter.formatDate(date) })
          this.tableFilter.dates.push(this.$formatter.formatDate(date))

          this.selectedYearMonth = this.tableFilter.dates[0].substring(0, 7)
          selectYearChanged = true
        } else if (this.tableFilter.dateType === 'custom') {
          if (this.$validate.DataValid(this.tableFilter.dates) && this.tableFilter.dates.length > 0) {
            this.selectedYearMonth = this.tableFilter.dates[0].substring(0, 7)
            selectYearChanged = true

            if (this.tableFilter.dates.length > 1 && this.tableFilter.dates[0] !== this.tableFilter.dates[1]) {
              payload['filter_item'].push({ key: 'start_date', value: this.tableFilter.dates[0] })
              payload['filter_item'].push({ key: 'end_date', value: this.tableFilter.dates[1] })
            } else {
              payload['filter_item'].push({ key: 'date', value: this.tableFilter.dates[0] })
            }
          }
        }

        if (this.$validate.DataValid(this.tableFilter.status)) {
          payload['filter_item'].push({ key: 'attendance_status', value: [this.tableFilter.status] })
        } else {
          payload['filter_item'].push({
            key: 'attendance_status',
            value: ['pending', 'attend', 'absent', 'await', 'sick_leave'],
          })
        }

        const { data, total } = await this.$Fetcher.GetStudentAttendances(this.id, payload)
        this.tableItemTotal = total
        this.tableData = data.map(el => {
          return {
            id: el.lesson_id,
            date: `${el.date} (${this.$d(this.$formatter.convertDate(el.date), 'weekdayShort')})`,
            start_time: el.start_time,
            end_time: el.end_time,
            course_code: el.course_code,
            course_name: el.course_name,
            attendance: el.attend_status,
            related_order: el.related_order,
            order_code: '',
          }
        })

        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].related_order) {
            this.tableData[i].order_code = await this.gfGenerateOrderId(this.tableData[i].related_order)
            if (this.tableData[i].order_code === 'abort') {
              this.tableData[i].order_code = ''
            }
          }
        }

        if (selectYearChanged) {
          this.getMonthAttendanceSummary()
        }
        this.tableLoading = false
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
        if (this.tableFilter.page === 1) {
          this.tableItemTotal = 0
        }
        this.tableLoading = false
        if (err === 'abort') {
          return false
        }
      }

      return true
    },
    dateTypeChanged() {
      this.tableFilter.dates = []
      if (this.tableFilter.dateType === 'custom') return
      this.search()
    },
    search() {
      this.tableFilter.page = 1
      this.tableItemTotal = 0
      this.getAttendanceData()
    },
    clearSearch() {
      this.tableFilter.dates = []
      this.tableFilter.status = null
      this.tableFilter.dateType = 'pass'
      this.search()
    },
    refreshData() {
      this.tableFilter.limit = 10
      this.search()
    },

    // ===== 課堂進度 =====
    // -- (課堂進度 View)
    async openViewProgress(lessonId) {
      this.progressTable.page = 1
      this.progressTable.total = 0
      this.progressTable.list = []
      this.progressTable.lesson_id = lessonId
      this.$refs.lessonProgressDialog.show('search_progress')
      this.getProgressData()
    },
    async getProgressData() {
      this.progressTable.loading = true
      try {
        const payload = {
          controller_name: 'search_progress',
          filter_page: this.progressTable.page - 1,
          filter_limit: this.progressTable.limit,
          filter_item: [
            { key: 'student_id', value: this.id },
            { key: 'lesson_id', value: this.progressTable.lesson_id },
          ],
        }
        const { data, total } = await this.$Fetcher.GetLessonProgresses(payload)
        this.progressTable.total = total
        this.progressTable.list = data.map(item => {
          return {
            ...item,
            create_date: `${item.create_date.substring(0, 10)} ${item.create_date.substring(11, 16)}`,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.progressTable.list = []
        if (this.progressTable.page === 1) {
          this.progressTable.total = 0
        }
      } finally {
        this.progressTable.loading = false
      }
    },
    previewVideo(link) {
      if (!link) return
      this.$store.dispatch('openMediaPopup', { media: link, isVideo: true })
    },

    // -- (課堂進度)
    async handleAddProgress(id = null, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        await this.$refs.progressDialog.resetForm()
        this.progressData.progress = ''
        this.progressData.comment = ''
        this.progressData.video_list = []

        if (this.$validate.DataValid(id)) {
          const found = this.progressTable.list.find(el => el.id === id)
          if (found) {
            this.progressData.progress = found.progress
            this.progressData.comment = found.comment
            if (found.video_id) {
              this.progressData.video_list = [
                {
                  file: null,
                  url: found.video_url || '',
                  name: found.custom_video_title || found.video_title || '',
                  video_id: found.video_id,
                  is_vimeo: true,
                },
              ]
            }
          }
        }
      } else {
      }

      const confirm = await this.$refs.progressDialog.show()
      if (confirm) {
        try {
          let payload = {
            progress: this.progressData.progress,
            comment: this.progressData.comment,
          }
          if (
            this.gEnableLessonProgressVideo &&
            this.$validate.DataValid(this.progressData.video_list, true) &&
            this.progressData.video_list[0].video_id
          ) {
            payload['video_id'] = this.progressData.video_list[0].video_id
          }
          if (this.$validate.DataValid(id)) {
            await this.$Fetcher.UpdateLessonProgress(id, payload)
          } else {
            await this.$Fetcher.NewLessonProgress(this.id, this.progressTable.lesson_id, payload)
          }

          if (this.$validate.DataValid(payload['video_id'])) {
            // remove video id from removedVimeoVideoIDList
            this.$store.dispatch('removeRemovedVimeoVideoID', payload['video_id'])
          }
          await this.removeVimeo()

          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.$refs.progressDialog.hide()

          const open = this.$refs.lessonProgressDialog.isOpen()
          if (open) {
            this.progressTable.loading = true
            setTimeout(() => {
              this.progressTable.page = 1
              this.getProgressData()
            }, 1000)
          }
        } catch (err) {
          this.showAlert({
            title: 'message.saveSuccess',
            message: err,
            isError: true,
          })
          this.handleAddProgress(id, false)
        }
      }
    },
    async removeVimeo() {
      const removeList = [...this.$store.getters.removedVimeoVideoIDList]
      return await this.removeUnusedVimeoVideo(removeList)
    },
    // -- (複製影片)
    copyVideo() {
      if (this.$validate.DataValid(this.progressData.video_list, true) && this.progressData.video_list[0].video_id) {
        const data = JSON.stringify(this.progressData.video_list[0])
        this.gfCopyText(data)
      }
    },
    // -- (貼上影片)
    async pasteVideo() {
      const text = await this.gfGetCopiedText()
      if (text) {
        try {
          const data = JSON.parse(text)
          if (
            typeof data === 'object' &&
            this.$validate.DataValid(data.video_id) &&
            this.$validate.DataValid(data.url)
          ) {
            let d = JSON.parse(JSON.stringify(data))
            d.is_vimeo = true
            this.progressData.video_list = [d]
          }
          this.$store.dispatch('toggleSnack', {
            message: 'message.copyVideoPasted',
            type: 'success',
          })
        } catch {}
      }
    },

    // -- (WhatsApp傳送課堂進度)
    async handleSendProgress(lessonId, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        this.wtsPhone = null
        this.wstPhoneOptions = []
        this.wtsMsg = ''

        this.$store.dispatch('setLoading', true)
        await this._getWtsStudent()
        await this._getLatestProgress(lessonId)
        this.$store.dispatch('setLoading', false)
      } else {
        this.$refs.selectWtsDialog.setLoading(false)
      }

      const confirm = await this.$refs.selectWtsDialog.show()
      if (confirm) {
        if (!this.$validate.DataValid(this.wtsPhone)) {
          this.$store.dispatch('toggleSnack', {
            message: 'message.noWtsPhone',
            type: 'error',
          })
          this.handleSendProgress(lessonId, false)
          return
        }
        const foundPhone = this.wstPhoneOptions.find(el => el.value === this.wtsPhone)
        window.open(
          `https://api.whatsapp.com/send?phone=852${foundPhone.data}&text=${this.wtsMsg.replace(
            /(?:\r\n|\r|\n)/g,
            '%0A',
          )}`,
          '_blank',
        )
        this.$refs.selectWtsDialog.hide()
      }
    },
    async _getWtsStudent() {
      try {
        this.wstPhoneOptions = []
        const data = await this.$Fetcher.GetStudentById(this.id)
        for (let i = 0; i < data.whatsapp_data.length; i++) {
          this.wstPhoneOptions.push({
            value: i,
            data: data.whatsapp_data[i].phone,
            text: `${data.whatsapp_data[i].name} ${data.whatsapp_data[i].phone}`,
          })
        }
        if (this.wstPhoneOptions.length) {
          this.wtsPhone = this.wstPhoneOptions[0].value
        }
      } catch (err) {
        this.$common.error(err)
      }
    },
    async _getLatestProgress(lessonId) {
      this.wtsMsg = ''
      const foundLesson = this.tableData.find(el => el.id === lessonId)
      if (foundLesson) {
        const getLatest = await this.$Fetcher.GetLatestProgress(this.id, lessonId)
        if (getLatest) {
          this.wtsMsg = this.$t('lessonProgressMsg', {
            lesson: `${foundLesson.date.substring(0, 10)} ${foundLesson.course_name}`,
            progress: getLatest.progress,
          })

          if (getLatest.comment) {
            this.wtsMsg += this.$t('lessonProgressMsgComment', { comment: getLatest.comment })
          }
        }
      }
    },

    // -- (搜尋影片)
    openSearchVideo() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.videoTable.loading = true
      this.videoTable.list = []
      this.videoTable.total = 0
      this.videoTable.page = 1
      this.videoTable.limit = 10
      this.$refs.searchVideoDialog.show('search_video')
      this.searchVideo()
    },
    async searchVideo() {
      this.videoTable.loading = true
      try {
        const getUser = this.gfGetCurrentUserData()
        let payload = {
          controller_name: 'search_video',
          filter_limit: this.videoTable.limit,
          filter_page: this.videoTable.page,
          access_token: getUser.access_token,
          refresh_token: getUser.refresh_token,
        }

        const { data, total } = await this.$Fetcher.GetVimeoVideos(payload)
        this.videoTable.total = total
        this.videoTable.list = data.map(el => {
          return {
            thumbnail: el.pictures && el.pictures.base_link ? el.pictures.base_link : '',
            duration: el.duration || 0,
            videoInput: {
              file: null,
              url: el.video_url,
              name: el.custom_video_title || el.video_title || '',
              video_id: el.video_id,
            },
          }
        })
      } catch (err) {
        this.$common.error(err)
        if (err === 'message.loginExpired') {
          this.$store.dispatch('toggleSnack', { message: err, type: 'error' })
        }
        this.videoTable.list = []
        if (this.videoTable.page === 1) {
          this.videoTable.total = 0
        }
      } finally {
        this.videoTable.loading = false
      }
    },
    handleSelectVideo(item) {
      if (item.videoInput && item.videoInput.video_id) {
        let d = JSON.parse(JSON.stringify(item.videoInput))
        d.is_vimeo = true
        this.progressData.video_list = [d]
        this.$refs.searchVideoDialog.hide()
      }
    },

    // -- (學生：課堂進度 View)
    async viewLatestProgress(lessonId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.$store.dispatch('setLoading', true)
      let comment = ''
      try {
        const getLatest = await this.$Fetcher.GetLatestProgress(this.id, lessonId)
        if (getLatest) {
          comment = getLatest.comment
        }
      } catch {}
      this.$store.dispatch('setLoading', false)
      this.showAlert({
        title: 'comment',
        message: comment || 'noComment',
        isError: false,
      })
    },

    async getSetting() {
      let data = null
      if (this.gEnableCustomGrade) {
        try {
          data = await this.$Fetcher.GetSetting()
        } catch (err) {
          this.$common.error(err)
        }
      }

      this.disableCourseGrade = this.gfCheckDisabledCourseGrade(data)
    },
    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: StudentAttendance')
      this.userType = this.gfGetUserType()
      this.userSelectedSchool = this.gfGetUserSelectedSchool()

      const id = parseInt(this.$route.params.id)
      if (!isNaN(id)) {
        this.id = id
      }
      if (this.userType === 'student') {
        const userData = this.gfGetCurrentUserData()
        this.id = userData.id
      }

      await this.getSetting()
      this.$store.dispatch('toggleLoadingPage', false)

      if (this.$validate.DataValid(this.id)) {
        await this.getStudentPackageInfo()
      }
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    this.tableLoading = true
    this.quotaLoading = true
    this.summaryLoading = true
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  created() {
    this.selectedYearMonth = this.$formatter.formatDate().substring(0, 7)

    if (!this.gEnableLessonLeaveStatus) {
      const foundStatus = this.attendanceStatusOptions.findIndex(el => el.value === 'await')
      if (foundStatus > -1) {
        this.attendanceStatusOptions.splice(foundStatus, 1)
      }
    }
  },

  // ------ navigation guard ------
  async beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else {
      // remove unused vimeo before leave
      await this.removeVimeo()
      this.$XHR.abort()
      next()
    }
  },
}
</script>

<style lang="scss">
.attendance-toolbar {
  & .toolbar-left-items {
    width: 100%;
    max-width: 100% !important;
    align-items: center;
  }
}

.attendance-toolbar__item {
  padding: 1em;
  color: #505050;
  font-size: 0.875rem;
  font-weight: 500;
}

.package-item {
  display: flex;
  justify-content: space-between;
  max-width: 200px;

  & * {
    font-size: 0.875rem;
    color: #505050;
    font-weight: 500;
  }
}

.btn-assign {
  min-width: unset !important;
  height: fit-content !important;
  & .v-btn__content {
    color: var(--v-primary-base) !important;
    opacity: 1 !important;
  }
}

@media (max-width: 992px) {
  .attendance-toolbar .custom-input {
    width: 100% !important;
    max-width: unset !important;
  }

  .attendance-toolbar__item {
    width: 25%;
  }
}

@media (max-width: 550px) {
  .attendance-toolbar__item {
    width: 50%;
  }
}
</style>
